import { Box, Button, Divider, Grid, MenuItem, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { app_title, endpoint } from "../../config";
import { useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { customToast } from "../../lib/toastLib";
import axios from "axios";
import MerchantRecords from "../../components/admin/MerchantRecords";
import getApplicationStatusFileList from "../../hooks/GET/applicationStatus";

export default function ApplicationStatusFileUploader() {
    const { t } = useTranslation();
    const [file, setFile] = useState(null);
    const [isSubmitBtnDisbaled, setIsSubmitBtnDisbaled] = useState(true)
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
		const [isApplication, setIsApplication] = useState(false)
    const [application, setApplication] = useState({
        open: false,
        records: [],
        merchantsCreatedRows: false,
        merchantsUpdatedRows: 0,
        title: "",
        tableTitle: ""
    })
    const [applicationstatusFileList, setApplicationstatusFileList] = useState([]);
    
    //table pagination logic start
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOption = [5, 10, 20];

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchData = () => {
      getApplicationStatusFileList()
        .then((data) => {
          setApplicationstatusFileList(data.data);
        })
        .catch((error) => console.log(error));
    };

    // Initial fetch
    fetchData();
    
    // Set up interval for periodic updates
    const intervalId = setInterval(fetchData, 30000);
    
    return () => clearInterval(intervalId);
  }, [isApplication]);

    useEffect(() => {
        setIsSubmitBtnDisbaled(file === null)
    }, [file])

    const handleFileChange = (e) => {
        if (!e.target.files.length) {
            setFile(null);
            customToast.error("No file selected");
            return;
        }

        const validExts = [".xlsx", ".xls", ".csv"];
        const fileName = e.target.files[0].name;
        const fileExt = fileName.substring(fileName.lastIndexOf("."));

        // invalid file type selected
        if (validExts.indexOf(fileExt) < 0) {
            document.getElementsByName("file")[0].value = "";
            setFile(null)
            customToast.error("Invalid file type");
            return;
        }
				
        setFile(e.target.files[0])
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnLoading(true)
        const formData = new FormData();
        formData.append("image_name", file);
        axios.post(`${endpoint}/api/upload-application-status-file`, formData).then(({ data }) => {
            if (data.errors && data.errors.length > 0) {
							setApplication({
                    open: true,
                    records: data.errors,
                    merchantsCreatedRows: false,
                    merchantsUpdatedRows: data.rowsUpdated || 0,
                    title: "Aplication Status",
                    tableTitle: `${data.errors.length} Errors found`
                })
            } else {
                setFile(null);
                setIsSubmitBtnDisbaled(true);
            }
						if(data.success){
							setIsApplication(true)
						}
            customToast.success(`${data.message}`)
        }).catch((error) => {
            if (error.response) {
                customToast.error(error.response.data?.message);
            } else {
                customToast.error(error.message);
            }
        }).finally(() => {
            setSubmitBtnLoading(false);
        })
    }

    const handleApiAplicationClose = () => {
        setApplication({
            open: false,
            records: [],
            merchantsCreatedRows: false,
            merchantsUpdatedRows: 0,
            title: ""
        })
    }

		const handleChangePage = (e, newPage) => {
			setPage(newPage - 1);
		};

    const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, applicationstatusFileList.length - page * rowsPerPage);

    return <>
        <Helmet>
            <title>Admin - Application Status File {app_title && `| ${app_title}` }</title>
        </Helmet>
        <Paper variant="outlined" sx={{ padding: 2 }}>
            <Typography
                variant="h6"
                fontWeight="bold"
                color="secondary.main"
                gutterBottom
            >
                {t("Application Status File")}
            </Typography>
            <Divider />
            <Grid
							container
							alignItems="center"
							spacing={3}
							sx={{ marginTop: 1 }}
							component="form"
							onSubmit={handleSubmit}
							autoComplete="off"
            >
                <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary">
                        {t("Choose file")}
                    </Typography>
                    <TextField
                        type="file"
                        margin="dense"
                        onChange={handleFileChange}
                        required
                        fullWidth
                        name="file"
                        helperText={`${t(
                            "Accepted file types"
                        )}: .xlsx only (PartnerReport)`}
                    />
                </Grid>
                <Grid item xs={12}>
                    <LoadingButton
                        color="primary"
                        variant="contained"
                        size="large"
                        fullWidth
                        type="submit"
                        disabled={isSubmitBtnDisbaled}
                        loading={submitBtnLoading}
                    >
                        {t("Upload")}
                    </LoadingButton>
                </Grid>
            </Grid>

            <Grid
							container
							justifyContent="space-between"
							alignItems="center"
							spacing={2}
							sx={{ marginY: 1 }}
						>
						<Grid item>
							<Typography sx={{ display: "contents" }}>{t("Show")}</Typography>
							<TextField
								select
								name="rowsPerPage"
								value={rowsPerPage}
								onChange={handleChangeRowsPerPage}
								size="small"
								sx={{ verticalAlign: "middle", margin: 1, minWidth: 75 }}
							>
								{rowsPerPageOption.map((option, idx) => (
									<MenuItem key={idx} value={option}>
										{option}
									</MenuItem>
								))}
							</TextField>
							<Typography sx={{ display: "contents" }}>{t("entries")}</Typography>
						</Grid>
        		</Grid>
        
						<TableContainer component={Paper} variant="outlined">
							<Table stickyHeader>
								<TableHead>
									<TableRow>
										<TableCell sx={{ width: '100px' }}>{t("Date")}</TableCell>
										<TableCell sx={{ width: '100px' }}>{t("File Name")}</TableCell>
										<TableCell align="center" sx={{ width: '100px' }}>{t("Status")}</TableCell>
										<TableCell align="center" sx={{ width: '100px' }}>{t("Rows Updated")}</TableCell>
										<TableCell sx={{ width: '240px' }}>{t("Error")}</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{(rowsPerPage > 0
										? applicationstatusFileList.slice(
												page * rowsPerPage,
												page * rowsPerPage + rowsPerPage
											)
										: applicationstatusFileList
									).map((fieldValue) => {
										const formattedDate = fieldValue?.created_at ? new Date(fieldValue.created_at).toLocaleDateString('en-CA', {
												year: 'numeric',
												month: '2-digit',
												day: '2-digit'
											}) : '-';
										return (
										<TableRow
											key={fieldValue.id}
											sx={{
												"&:last-child td, &:last-child th": { border: 0 },
											}}
										>
											<TableCell component="th" scope="row" >
												{formattedDate}
											</TableCell>
											<TableCell>{fieldValue.file_name}</TableCell>
											<TableCell align="center">{fieldValue.status}</TableCell>
											<TableCell align="center">{fieldValue.rows_updated}</TableCell>
											<TableCell key={fieldValue.id}>
												{ fieldValue.errors.split("\n").map((error, idx) => (
														<Box sx={{
															display: "flex",
															flexDirection: "column",
														}} key={idx}>
															{error}
														</Box>
												))}
											</TableCell>
										</TableRow>
										)               
									})}
									{emptyRows > 0 && (
										<TableRow style={{ height: 67 * emptyRows }}>
											<TableCell align="center" colSpan={5}>
												{applicationstatusFileList.length === 0 &&
													t("No application status file available to display")}
											</TableCell>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>
						<MerchantRecords
								title={application.title}
								open={application.open}
								records={application}
								handleClose={handleApiAplicationClose}
								showHeading={false}
						/>

{applicationstatusFileList.length > 0 && (
          <Grid container justifyContent="center" sx={{ mt: 2 }} spacing={1}>
            <Grid item>
              <Button
                size="small"
                onClick={(e) => handleChangePage(e, page)}
                disabled={page === 0}
              >
                {t("Previous")}
              </Button>
            </Grid>
            <Grid item>
              <Pagination
                count={Math.ceil(applicationstatusFileList.length / rowsPerPage)}
                page={page + 1}
                onChange={handleChangePage}
                variant="outlined"
                shape="rounded"
                color="secondary"
                hidePrevButton
                hideNextButton
              />
            </Grid>
            <Grid item>
              <Button
                size="small"
                onClick={(e) => handleChangePage(e, page + 2)}
                disabled={
                  Math.ceil(applicationstatusFileList.length / rowsPerPage) === page + 1
                }
              >
                {t("Next")}
              </Button>
            </Grid>
          </Grid>
        )}
        </Paper>
    </>
}